import type { LanguageCode } from "@/components/translations";

// Teacher (ранее Resident)
export interface TeacherTranslation {
  id: string;
  teacherId: string;
  languageCode: LanguageCode;
  name: string;
  role: string | null;
  bio: string | null;
}

export interface Teacher {
  id: string;
  userId: number | null;
  photoUrl: string | null;
  photoId: number | null;
  socialLinks: Record<string, string>;
  isActive: boolean;
  order: number;
  createdAt: string;
  translations: TeacherTranslation[];
  _count?: {
    courses: number;
    posts: number;
  };
}

export interface TeacherFormData {
  photoUrl: string | null;
  photoId: number | null;
  socialLinks: Record<string, string>;
  isActive: boolean;
  order: number;
  translations: { languageCode: LanguageCode; name: string; role: string | null; bio: string | null }[];
}

export function getTeacherName(teacher: Teacher, lang: LanguageCode = "ru"): string {
  return teacher.translations?.find((t) => t.languageCode === lang)?.name ?? "Без имени";
}

